import { api } from "@/lib/api";
import { Activity } from "@/types";
import { StaffActivity } from "@/types/activity.types";

interface ActivityApiResponse {
  status: string;
  message: string;
  data: Activity[];
}

interface StaffActivityApiResponse {
  status: string;
  message: string;
  data: StaffActivity[];
}

export const activityService = {
  async getAllActivities(): Promise<Activity[]> {
    const response = await api.get<ActivityApiResponse>("/activity");
    return response.data.data;
  },

  async getStaffActivities(): Promise<StaffActivity[]> {
    const response = await api.get<StaffActivityApiResponse>("/activity/staff");
    return response.data.data;
  },
};